import { graphql, useStaticQuery } from 'gatsby';
import { Query } from '../types/graphql-types';

export const availableLocales = () => {
  const data: Query = useStaticQuery(graphql`
    query {
      allContentfulService {
        edges {
          node {
            node_locale
          }
        }
      }
    }
  `);

  if (!data || !data.allContentfulService || !data.allContentfulService.edges) {
    return;
  }

  // Get all locales
  const locales = data.allContentfulService.edges
    .filter(edge => edge && edge.node && edge.node.node_locale)
    .map(edge => edge!.node!.node_locale as string);

  // Return distinct locales
  return Array.from(new Set(locales));
};
